import { render, staticRenderFns } from "./EnviarEmailPedidosEmSeparacaoAtual.vue?vue&type=template&id=0b806920&scoped=true"
import script from "./EnviarEmailPedidosEmSeparacaoAtual.vue?vue&type=script&setup=true&lang=js"
export * from "./EnviarEmailPedidosEmSeparacaoAtual.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b806920",
  null
  
)

export default component.exports